<template>
	<el-dialog v-model="innerVisible"  :close-on-click-modal="false" title="采购单入库" width="92%" height="400px"  style="height: 400px;" custom-class="zero-padding-modal" @open="openInit" @opened="openedInit" @closed="closeDeal">
		<template #default>			
			<div class="assemble-edit-modal-content">
				<el-form :model="addForm" label-width="130px" ref="dialogRef" :rules="formRules" style="margin:20px 20px 0 0;margin-top: 20px;" >
					<el-row>
						<el-col :span="6">
							<el-form-item label="采购单号:" prop="ProcureNo">
								<el-input v-model="addForm.ProcureNo" placeholder="请输入采购单号" clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="采购单别:" prop="ProcureType">
								<el-input v-model="addForm.ProcureType" clearable placeholder="请输入采购单别" />
							</el-form-item>
						</el-col> 
						<el-col :span="8">
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" @click="searchData">提交</el-button>
								<el-button icon="el-icon-refresh-right" @click="reset">重置</el-button>
								
							</el-form-item>
						</el-col>                              
					</el-row>
					<!-- /////////////////////////////////////////////////////////// -->
					<el-row>
						<el-col :span="12" >
							<el-form-item label="托盘编号或库位编号:" prop="conVsLonCode" label-width="210px">
								<el-input v-model="addForm.conVsLonCode" placeholder="请输入托盘编号或库位编号" clearable></el-input>
							</el-form-item>
						</el-col>				                             
					</el-row>					
				</el-form>	
				<div class="modal-content-list">
					<div class="list-padding">
						<el-table :data="list" border row-key="tableKey"  @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="60" align="center" :selectable="selectableFunction"></el-table-column>
							<el-table-column label="序号" align="center" width="60">
								<template #default="scope">{{scope.$index+1}}</template>
							</el-table-column>
							<el-table-column label="项目编号" prop="projectCode" align="center" width=""/>
							<el-table-column label="品号" prop="code" align="center" width=""/>
							<el-table-column label="品名" prop="name" align="center" width="250"/>
							<el-table-column label="规格型号" prop="specificationModel" align="center" width="350"/>
							<el-table-column label="单位" prop="unit" align="center" width="60"/>							
							<!-- <el-table-column label="容器编号" prop="containerCode" align="center" width=""/> -->
							<!-- <el-table-column label="库位编号" prop="locationCode" align="center" width=""/> -->
							<!-- <el-table-column label="库位状态" align="center" width="">
							  <template #default="scope">
							    <span>{{ localStatus(scope.row.locationStatus) }}</span>
							  </template>
							</el-table-column> -->
							<el-table-column label="库存数" prop="bindQuantity" align="center" width=""/>
							<el-table-column label="入库数" width="" align="center">
							  <template #default="scope">
									<el-input-number v-model="scope.row.quatity" :min="1" :max="scope.row.bindQuantity" size="small" />
							  </template>
							</el-table-column>
							<!-- <el-table-column label="转入库位" prop="transferredILocation" align="center" width=""/> -->
														
							<el-table-column label="操作" width="80" align="center">
							  <template #default="scope">
							    <el-button type="danger" size="small" @click="onDel(scope.$index)">删除</el-button>
							  </template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>					
		</template>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="onBtnClose">取 消</el-button>
				<el-button type="primary" :disabled="choosen.length===0&&addForm.conVsLonCode==''" @click="confirm">提 交</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
import { defineEmits, ref, computed,watch, toRefs,reactive,nextTick } from 'vue'	
// import ChooseMaterialModal from './ChooseMaterialModal.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { PcInStock, ErpOrderDetails } from '@/service/main/statistical/index'
// import { localStatus } from '../../switchCase'
import ElUpload from "element-plus/lib/el-upload";
const emits = defineEmits(['update:visible','loadInitData','callback'])
import { exportExcel } from "@/utils/exportExcel";
const props = defineProps({
	visible:{
		type:Boolean,
		default:false
	},
	editDetails:{
		type:Array,
		default:()=>{
			return []
		}
	},
	mainEdit:{
		type:Object,
		default:()=>{
			return {}
		}
	},	
	type:{
		type:String,
		default:'info'
	},
	orderId:{
		type:[String,Number],
		default:''
	}
})
//////////////////////////////////
const formRules = {
    ProcureNo: [{ required: true, message: "采购单号不能为空", trigger: "blur" }],
    ProcureType: [{ required: true, message: "采购单别不能为空", trigger: "blur" }],
	conVsLonCode: [{ required: true, message: "托盘编号或库位编号不能为空", trigger: "blur" }]
}
// 编辑送货预约窗口中表单数据绑定
const addForm = ref({
	ProcureNo:"",
    ProcureType: "",
	conVsLonCode:""
})
const { visible, type, orderId,editDetails,mainEdit } = toRefs(props)

const innerVisible = ref(false)
const title = ref('')
const chooseVisieble = ref(false)
const list = ref([])
const choosen = ref([])

watch(
	visible,
	function(newVal){
		if (innerVisible.value!==newVal) {
			innerVisible.value = newVal
		}
	},
	{immediate:true}
)
watch(innerVisible,function(newVal){
	if (visible.value!==newVal) {
		emits('update:visible',newVal)
	}
})

const closeDeal = function(){
	selfClose()
}

const onBtnClose = function(){
	selfClose()
}

const selfClose = function(){
	innerVisible.value = false
    addForm.value.ProcureType = ""
    addForm.value.ProcureNo = ""
    addForm.value.conVsLonCode = ""
	addForm.value = {}
	list.value = []
}

const checkBeforeSubmit = function() {
	let n = -1
	for (let i=0;i<list.value.length;i++) {
		if (list.value[i].orderQuantity<=0) {
			n = i;
			break
		}
	} 
	if (n===-1) {
		return true
	} else {
		ElMessageBox.alert(`第${n+1}笔物料出库数错误。`,'系统提示')
		return false
	}
}
const dialogRef = ref()
const confirm = function(){
	dialogRef.value.validate((valid) => {
        if (valid) {
            let f = checkBeforeSubmit()
			if (!f) return flase		
			addForm.value.orderContainerVsMaterial = list.value
			addForm.value.orderContainerVsMaterial.forEach(item=>{
				item.bindQuantity = item.quatity
			})
			console.log('addForm',addForm.value)
			PcInStock(addForm.value).then((res) => {
				ElMessage.success("操作成功")
				selfClose()
				emits('callback')
			}).catch(()=>{
				// callback && callback(false)
			})			
        } 
    })	
}

const openedInit = function(){	
	// list.value = []	
	// ErpOrderDetails(addForm.value).then((res) => {
	// 	console.log('11111',res)
	// 	list.value = res.data.orderContainerVsMaterial
	// }).catch((err)=>{
	// 	//console.log(err)
	// })
}
const searchData = function(){	
	list.value = []	
	ErpOrderDetails(addForm.value).then((res) => {
		list.value = res.data.orderContainerVsMaterial
		list.value.forEach(item=>{
			item.quatity = item.bindQuantity
		})
	}).catch((err)=>{
		//console.log(err)
	})
}

const openInit = function(){
	// setTitle()
}
const setTitle = function(){
	if (type.value==='modify') {
		title.value = '修改单据'
	} else {
		title.value = '新增单据'
	}
}
const getModifyInitData = function(){
	emits('loadInitData',{id:orderId.value,PageNo:1,PageSize:9999},function(f,d){
		if (f) {
			list.value = (d.data.rows || []).map((obj,index)=>{
				obj.tableKey = 'edit-' + new Date().getTime() + '-' + index
				return obj
			})
		}
	})
}


const handleSelectionChange = (val) => {
	choosen.value = val
}


const checkMaterialExist = function(obj) {
	let res = false
	for (let i=0;i<list.value.length;i++) {
		if (list.value[i].code===obj.code && list.value[i].locationCode===obj.locationCode) {
			res = true
			break
		}
	}
	return res
}

const onDel = function(index) {
	list.value.splice(index,1)
}


</script>

<style lang="less" scoped>
.assemble-edit-modal-content{
	height: 60vh;
	display: flex;
	flex-direction: column;
	
	.modal-content-list{
		flex-grow: 1;
		height: 1px;
		overflow: auto;
		.list-padding{
			padding: 0 16px;
		}
	}
}
</style>